import i18n from 'i18next';
import { resolveLocalizedString } from './resolveLocalizedString';

/**
 * Resolve a LocalizedString to a display string using the CURRENT i18n locale.
 * Falls back through: translations[currentLocale] → translations[en-US] → default → fallback.
 *
 * Use for publisher-authored content (approach names, channel descriptions).
 * For platform UI strings, use t() from i18next instead.
 *
 * This is the i18n-bound convenience wrapper over `resolveLocalizedString`, which owns the
 * precedence chain and takes the locale as a parameter. Callers that already have a locale in
 * hand (a `useTranslation()` result, a server-supplied locale) should use that one directly;
 * this exists so the 100+ call sites with no locale in scope don't each reach for `i18n`.
 * Keeping one implementation is the point — the divergent copies this replaced could label the
 * same channel differently on two screens.
 */
export function getLocalizedText(
  value: { translations?: Record<string, string>; default?: string } | string | undefined | null,
  fallback = ''
): string {
  return resolveLocalizedString(value, fallback, i18n.language || 'en-US');
}
